import { Log } from '@utils';

export class NotificationsApi {

	protected title: string;
	protected options: NotificationOptions;

	constructor(options: NotificationOptions) {
		this.options = options;
	}

	async showUp( { title, body, options }: { title?: string; body: string; options?: NotificationOptions }) {
		await NotificationsApi.show(title, { ...options, body });
	}

	static async show(title: string, options?: NotificationOptions) {
		try {
			const permission = await Notification.requestPermission();

			if (permission === 'granted') {
				try {
					const registration = await navigator?.serviceWorker?.ready;

					await registration.showNotification(title, options);
				} catch (err) {
					Log.error(`NotificationsApi; serviceWorker registration error: ${err}`);
				}
			}
		} catch (err) {
			Log.error(`NotificationsApi; requestPermission errorL ${err}`);
		}
	}

}
